import {
    LeftOutlined,
    ReloadOutlined,
    RightOutlined,
    ZoomInOutlined,
    ZoomOutOutlined,
} from '@ant-design/icons'
import { Input } from 'antd'

import Box from '~/core/Box'
import Button from '~/core/Button'
import Image from '~/core/Image'
import Text from '~/core/Text'
import styles from '~/apps/consumer/components/PartViewerModal/styles.css'
import {
    getInputStyle,
    formatDateForInspectionDocument,
} from '~/apps/consumer/components/PartViewerModal/logic'
import { CarouselType } from '~/apps/consumer/components/PartViewerModal/types'
import { MIN_SCALE } from '~/apps/consumer/components/PartViewerModal/components/PartDetails/components/InspectionReport/logic'

export default function Carousel(props: CarouselType) {
    const {
        setRotationDegreeInspectionDocument,
        selectedInspectionDocument,
        rotationDegree,
        backDisabled,
        prevPhoto,
        changeAttachmentInputField,
        attachmentInputField,
        fictiv5sAndPhotosLength,
        fwdDisabled,
        nextPhoto,
        scale,
        handleZoomScaleToggle,
        fileName,
        createdAt,
        placement,
        selectedDocdownloadUrl,
    } = props

    const setRotation = (isCounterClockWise: boolean) =>
        setRotationDegreeInspectionDocument(
            isCounterClockWise,
            selectedInspectionDocument,
            rotationDegree,
        )
    const zoomToggle = (zoomIn: boolean) =>
        handleZoomScaleToggle(zoomIn, selectedInspectionDocument)
    const leftIconStyle = getInputStyle(backDisabled)
    const nextIconStyle = getInputStyle(fwdDisabled)
    const disableZoomOut = scale === MIN_SCALE

    return (
        <>
            <Box style={{ overflow: 'auto' }}>
                <Box
                    width="100%"
                    height="100%"
                    className={styles.imageWrapper}
                    style={{
                        transform: `scale(${scale})`,
                        transformOrigin: `0% 0%`,
                    }}
                >
                    <Image
                        width="100%"
                        height="100%"
                        src={selectedDocdownloadUrl}
                        style={{
                            transform: `rotate(${rotationDegree}deg)`,
                            transformOrigin: `50% 50%`,
                            objectFit: 'scale-down',
                        }}
                    />
                </Box>
            </Box>
            <Box width="100%" marginTop="12px">
                <Box
                    justifyContent="start"
                    width="100%"
                    minWidth="268px"
                    style={{
                        overflowX: 'auto',
                    }}
                    padding="0 16px 16px 16px"
                >
                    <Box
                        direction="col"
                        flex="2"
                        justifyContent="center"
                        maxWidth="40%"
                    >
                        <Text fontSize="14px" className={styles.ellipsis}>
                            {fileName}
                        </Text>
                        <Text
                            color="blackAlpha45"
                            style={{ alignSelf: 'flex-start' }}
                            fontSize="14px"
                        >
                            {formatDateForInspectionDocument(createdAt)}
                        </Text>
                    </Box>
                    <Box flex="1" justifyContent="center" alignItems="center">
                        <LeftOutlined
                            style={{
                                marginRight: 15,
                                cursor: leftIconStyle.CURSOR,
                                color: leftIconStyle.COLOR,
                            }}
                            onClick={prevPhoto}
                        />
                        <Input
                            value={
                                attachmentInputField === ''
                                    ? attachmentInputField
                                    : selectedInspectionDocument + 1
                            }
                            size="small"
                            style={{
                                width: 48,
                                textAlign: 'center',
                                MozAppearance: 'textfield',
                                WebkitAppearance: 'textfield',
                            }}
                            type="number"
                            onChange={changeAttachmentInputField}
                            onClick={(event: any) => {
                                event.target.select()
                            }}
                        />
                        <Text style={{ margin: '0 15px' }}>/</Text>
                        <Text>{fictiv5sAndPhotosLength}</Text>
                        <RightOutlined
                            style={{
                                marginLeft: 15,
                                cursor: nextIconStyle.CURSOR,
                                color: nextIconStyle.COLOR,
                            }}
                            onClick={nextPhoto}
                        />
                    </Box>
                    <Box flex="2" alignItems="center" justifyContent="end">
                        <Button
                            className={styles.fileListButton}
                            name="zoom-in"
                            placement={placement}
                            onClick={() => zoomToggle(true)}
                        >
                            <ZoomInOutlined />
                        </Button>
                        <Button
                            className={styles.fileListButton}
                            name="zoom-out"
                            placement={placement}
                            disabled={disableZoomOut}
                            onClick={() => zoomToggle(false)}
                        >
                            <ZoomOutOutlined />
                        </Button>
                        <Button
                            name="rotation"
                            placement={placement}
                            onClick={() => setRotation(true)}
                            className={styles.fileListButton}
                        >
                            <ReloadOutlined />
                        </Button>
                        <Button
                            name="rotation-clockwise"
                            placement={placement}
                            onClick={() => setRotation(false)}
                            className={styles.fileListButton}
                        >
                            <ReloadOutlined
                                className={styles.antiClockWiseRotation}
                            />
                        </Button>
                    </Box>
                </Box>
            </Box>
        </>
    )
}
